import { LuMail, LuPhone, LuX } from 'react-icons/lu'

import { ModalBase } from '@/lib/core/components/Modal'

import { helpModalContent } from './HelpModal.utils'
import styles from './HelpModal.module.css'

export type HelpModalProps = {
  isActive: boolean
  onClose: () => void
}

export const HelpModal = ({ isActive, onClose }: HelpModalProps) => {
  const { title, support, releaseNotes } = helpModalContent

  return (
    <ModalBase isActive={isActive} onEscape={onClose}>
      <div data-testid="help-modal" className={styles.modalContainer}>
        <div className={styles.modalHeader}>
          <div>
            <div className={styles.modalHeaderTitle}>{title}</div>
          </div>
          <div className={styles.modalHeaderActions}>
            <button
              data-testid="help-modal-close-button"
              className={styles.modalCloseButton}
              type="button"
              onClick={() => onClose()}
            >
              <LuX size={22} />
            </button>
          </div>
        </div>
        <div className={styles.modalFooter}>
          <div data-testid="help-modal-support" className={styles.modalFooterCategory}>
            <div className={styles.modalFooterCategoryHeader}>{support.heading}</div>
            <div className={styles.modalFooterCategoryContent}>
              <LuPhone size={20} /> {support.phone}
            </div>
            <div className={styles.modalFooterCategoryContent}>
              <LuMail size={20} />
              <a
                data-testid="help-modal-support-email"
                href={`mailto:${support.email}`}
                className={styles.modalContentCategoryItem}
              >
                {support.email}
              </a>
            </div>
          </div>
          <div data-testid="help-modal-release-notes" className={styles.modalFooterCategory}>
            <div className={styles.modalFooterCategoryHeader}>{releaseNotes.heading}</div>
            <div>
              <a
                data-testid="help-modal-release-notes-link"
                href={releaseNotes.url}
                target="_blank"
                className={styles.modalContentCategoryItem}
              >
                {releaseNotes.label}
              </a>
            </div>
          </div>
        </div>
      </div>
    </ModalBase>
  )
}
